export enum ProcessType {
  P2W_RETURN = 'p2w_return',
  D2W = 'd2w',
}
